import { render, staticRenderFns } from "./WModal.vue?vue&type=template&id=359a605a&scoped=true&"
import script from "./WModal.vue?vue&type=script&lang=js&"
export * from "./WModal.vue?vue&type=script&lang=js&"
import style0 from "./WModal.vue?vue&type=style&index=0&id=359a605a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359a605a",
  null
  
)

export default component.exports